import { TItemWithChildren } from 'partner360/components/QBR/shared/financialDataVisualizer/models'

interface IBuildHierarchyGroups<T> {
  items: T[]
  parentId?: number | null
}

export const buildHierarchyGroups = <T extends { ParentId: number | null; EntryId: number }>({
  items,
  parentId = null,
}: IBuildHierarchyGroups<T>): TItemWithChildren<T>[] => {
  const result = []

  for (const item of items) {
    if (item.ParentId === parentId) {
      const itemWithChildren: TItemWithChildren<T> = { ...item }
      const children = buildHierarchyGroups({ items, parentId: item.EntryId })

      if (children.length > 0) {
        itemWithChildren.children = children
      }

      result.push(itemWithChildren)
    }
  }

  return result
}
